var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mobile-menu-icon",class:[_vm.iconActive ? 'active' : ''],on:{"click":_vm.setIconActive}},[_c('span')])
}
var staticRenderFns = []

export { render, staticRenderFns }